const confirmDeletion = (string: string) => {
  return window.confirm(`Are you sure you want to delete this ${string}?`);
};

const confirmDuplication = (string: string) => {
  return window.confirm(`Are you sure you want to duplicate this ${string}?`);
};

export { confirmDeletion, confirmDuplication };
